module.exports = __webpack_public_path__ + "static/img/v2.11c7b738.png";